import EchartsDataDeal from '../component/options/echartsDataDeal.js'

import getEchartsOptionBarA1 from '../component/options/echartsOptionBarA1.js'
import getEchartsOptionBarB1 from '../component/options/echartsOptionBarB1.js'
import getEchartsOptionBarB2 from '../component/options/echartsOptionBarB2.js'
import getEchartsOptionBarC1 from '../component/options/echartsOptionBarC1.js'
import getEchartsOptionBarC2 from '../component/options/echartsOptionBarC2.js'
import getEchartsOptionBarC3 from '../component/options/echartsOptionBarC3.js'
import getEchartsOptionBarC4 from '../component/options/echartsOptionBarC4.js'
import getEchartsOptionBarC5 from '../component/options/echartsOptionBarC5.js'
import getEchartsOptionBarC6 from '../component/options/echartsOptionBarC6.js'
import getEchartsOptionBarC7 from '../component/options/echartsOptionBarC7.js'
import getEchartsOptionBarC8 from '../component/options/echartsOptionBarC8.js'
import getEchartsOptionBarC9 from '../component/options/echartsOptionBarC9.js'
import getEchartsOptionBarC10 from '../component/options/echartsOptionBarC10.js'
import getEchartsOptionBarD1 from '../component/options/echartsOptionBarD1.js'
import getEchartsOptionBarE1 from '../component/options/echartsOptionBarE1.js'
import getEchartsOptionLineC1 from '../component/options/echartsOptionLineC1.js'
import getEchartsOptionLineD1 from '../component/options/echartsOptionLineD1.js'
import getEchartsOptionLineD2 from '../component/options/echartsOptionLineD2.js'
import getEchartsOptionLineD3 from '../component/options/echartsOptionLineD3.js'
import getEchartsOptionLineD4 from '../component/options/echartsOptionLineD4.js'
import getEchartsOptionLineE1 from '../component/options/echartsOptionLineE1.js'
import getEchartsOptionScatterA1 from '../component/options/echartsOptionScatterA1.js'
import getEchartsOptionFloatA1 from '../component/options/echartsOptionFloatA1.js'
import getEchartsOptionFloatA2 from '../component/options/echartsOptionFloatA2.js'
import getEchartsOptionFloatA3 from '../component/options/echartsOptionFloatA3.js'


function getNeedOption(item, type) { // 获取图表 option
	if (item.index == 'brePauseNum' || item.index == 'heartFastNum' || item.index == 'fallStopNum' || item.index == 'heartSlowNum' || item.index == 'breFastNum' || item.index == 'fallNum' || item.index == 'outBedNum') {
		// 1.获取分钟数组
		let minutes = [];
		if (item && item.xaxis) {
			for (let i = 0; i < item.xaxis.length; i++) {
				let x = item.xaxis[i];
				if (x.indexOf(':') >= 0) {
					let hourMinuteArr = x.split(":");
					let hour = parseInt(hourMinuteArr[0]);
					let minute = parseInt(hourMinuteArr[1]);
					let needMinute = hour * 60 + minute;
					minutes.push(needMinute);
				}
			}
		}
		// 2.获取Y轴的值
		let values = [];
		if (item && item.xaxis) {
			for (let i = 0; i < item.data.length; i++) {
				let value = item.data[i];
				if (!value) {
					values.push(0);
				} else {
					values.push(value.length);
				}
			}
		}
		let xAxis_data = JSON.parse(JSON.stringify(minutes));
		let series_data = JSON.parse(JSON.stringify(values));
		let expansion_data = JSON.parse(JSON.stringify(item.data || []));
		let markArea_range = [];
		return getEchartsOptionBarA1(xAxis_data, series_data, expansion_data, markArea_range);
	} else if (item.index == 'breBpm3Num' || item.index == 'breBpm2Num') {
		let dealData = EchartsDataDeal.deal_bar_chart_1(item)
		return getEchartsOptionBarB1(dealData.xAxis_data, dealData.series_data, dealData.markArea_range)
	} else if (item.index == 'heartBpm3Num' || item.index == 'heartBpm2Num') {
		let dealData = EchartsDataDeal.deal_bar_chart_1(item)
		return getEchartsOptionBarB2(dealData.xAxis_data, dealData.series_data, dealData.markArea_range)
	} else if (item.index == '') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		return getEchartsOptionBarC1(xAxis_data, series_data, expansion_data, markArea_range, type == 0);
	} else if (item.index == '') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		return getEchartsOptionBarC2(xAxis_data, series_data, expansion_data, markArea_range, type == 0);
	} else if (item.index == '') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		return getEchartsOptionBarC3(xAxis_data, series_data, expansion_data, markArea_range, type == 0);
	} else if (item.index == '') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		return getEchartsOptionBarC4(xAxis_data, series_data, expansion_data, markArea_range, type == 0);
	} else if (item.index == 'bcFallAsleep2Num' || item.index == 'obTime2Num') {
		if (item.index == 'obTime2Num') {
			return null
		}
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		let colorArr = item.dataTrend || [];
		return getEchartsOptionBarC5(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	}
	//  else if (item.index == 'obCnt' || item.index == 'obCnt3Num') {
	// 	let xAxis_data = item.xaxis || [];
	// 	let series_data = item.data || [];
	// 	let expansion_data = item.xaxisCn || [];
	// 	let markArea_range = item.range;
	// 	let colorArr = item.dataTrend || [];
	// 	return getEchartsOptionBarC6(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	// } 
	else if (item.index == 'sleepEff' || item.index == 'sleepEff3Num') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		let colorArr = item.dataTrend || [];
		return getEchartsOptionBarC7(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == 'sleepTime2Num' || item.index == 'sleepTime3Num' || item.index == 'sleepTime') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		let colorArr = item.dataTrend || [];
		return getEchartsOptionBarC8(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == 'bcFallAsleep') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range;
		let colorArr = item.dataTrend || [];
		return getEchartsOptionBarC9(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == 'obTimeLen2') {
		let tempXaxisData = [];
		let tempXaxisCn = [];
		let tempData = [];
		let tempFlag = [];
		let tempStartTime = [];
		let colorTypeArr = [];
		if (item && item.data) {
			for (let i = 0; i < item.data.length; i++) {
				let subItem = item.data[i];
				if (subItem.timeDuration && subItem.timeDuration.length > 0) {
					for (let j = 0; j < subItem.timeDuration.length; j++) {
						let subSubItem = subItem.timeDuration[j];
						tempXaxisData.push(subItem.date);
						tempXaxisCn.push(subItem.dateCn);
						tempData.push(subSubItem.duration);
						tempFlag.push(subSubItem.changeFlag);
						tempStartTime.push(subSubItem.timeSt);
						if (subSubItem.changeFlag == true) {
							if (i == item.data.length - 1) {
								colorTypeArr.push(4)
							} else {
								colorTypeArr.push(3)
							}
						} else {
							if (i == item.data.length - 1) {
								colorTypeArr.push(2)
							} else {
								colorTypeArr.push(1)
							}
						}
					}
				} else {
					tempXaxisData.push(subItem.date);
					tempXaxisCn.push(subItem.dateCn);
					tempData.push(null);
					tempFlag.push(false);
					tempStartTime.push(null);
					colorTypeArr.push(1)
				}
			}
		}
		let xAxis_data = tempXaxisData || [];
		let series_data = tempData || [];
		let expansion_data = tempXaxisCn || [];
		let expansion_data_2 = tempFlag || [];
		let expansion_data_3 = tempStartTime || [];
		let markArea_range = item.range;
		return getEchartsOptionBarC10(xAxis_data, series_data, expansion_data, expansion_data_2, expansion_data_3, markArea_range, type == 0, colorTypeArr);
	} else if (item.index == 'ahi') {
		let tempDict = item.extendData.breathExEventNewVo;
		if (tempDict) {
			let xAxis_data = tempDict.xtimeAxis || [];
			let series_data = tempDict.data || [];
			let expansion_data = tempDict.duration || [];
			return getEchartsOptionBarD1(xAxis_data, series_data, expansion_data);
		}
	} else if (item.index == 'getBed' || item.index == 'sleepSt' || item.index == 'sleepEd' || item.index == 'leaveBed') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		let colorArr = item.dataTrend || [];
		return getEchartsOptionLineC1(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == 'fallIndex' || item.index == 'bmRatio2Num') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		let colorArr = item.dataTrend || [];
		return getEchartsOptionLineD1(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == 'sleepBreak' || item.index == 'sleepBreak2Num') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		let colorArr = item.dataTrend || [];
		return getEchartsOptionLineD2(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == '') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		let colorArr = item.dataTrend || [];
		return getEchartsOptionLineD3(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == 'breRatio' || item.index == 'bmRatio') {
		let xAxis_data = item.xaxis || [];
		let series_data = item.data || [];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		let colorArr = item.dataTrend || [];
		return getEchartsOptionLineD4(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr);
	} else if (item.index == '') {
		let needDataMin = [];
		let needDataMedian = [];
		let needDataMax = [];
		let tempArr = JSON.parse(JSON.stringify(item.data || []));
		for (let i = 0; i < tempArr.length; i++) {
			let item = tempArr[i];
			needDataMin.push(item.min);
			needDataMedian.push(parseInt(item.median));
			needDataMax.push(item.max - item.min);
		}
		let xAxis_data = item.xaxis || [];
		let series_data = [
			{ data: needDataMin },
			{ data: needDataMax },
			{ data: needDataMedian },
		];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		return getEchartsOptionFloatA1(xAxis_data, series_data, expansion_data, markArea_range, type == 0)
	} else if (item.index == 'heartBpm') {
		let needDataMin = [];
		let needDataMedian = [];
		let needDataMax = [];
		let tempArr = JSON.parse(JSON.stringify(item.data || []));
		for (let i = 0; i < tempArr.length; i++) {
			let item = tempArr[i];
			needDataMin.push(item.min);
			needDataMedian.push(parseInt(item.median));
			needDataMax.push(item.max - item.min);
		}
		let xAxis_data = item.xaxis || [];
		let series_data = [
			{ data: needDataMin },
			{ data: needDataMax },
			{ data: needDataMedian },
		];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		let colorArr = item.dataTrend || [];
		return getEchartsOptionFloatA2(xAxis_data, series_data, expansion_data, markArea_range, type == 0, colorArr)
	} else if (item.index == 'bcRegular2Num') {
		let dealData = EchartsDataDeal.deal_law_scatter_chart_data(item);
		return getEchartsOptionScatterA1(
			dealData.xAxis_data,
			dealData.yAxis_data,
			dealData.series_data0,
			dealData.series_data1,
			dealData.series_data2,
			dealData.series_data3,
			dealData.scatter_interval1,
			dealData.scatter_interval2,
			dealData.scatter_interval3,
			dealData.scatter_interval4
		)
	} else if (item.index == 'breBpm') {
		let needDataMin = [];
		let needDataMedian = [];
		let needDataMax = [];
		let deviateFlags = [];
		let tempArr = JSON.parse(JSON.stringify(item.data || []));
		for (let i = 0; i < tempArr.length; i++) {
			let item = tempArr[i];
			if (item && item.extendData && item.extendData.deviateFlag == 3) {
				needDataMin.push(0);
				needDataMedian.push(parseInt(item.median));
				needDataMax.push(0);
			} else {
				needDataMin.push(item.min);
				needDataMedian.push(parseInt(item.median));
				needDataMax.push(item.max - item.min);
			}
			deviateFlags.push(item.extendData && item.extendData.deviateFlag ? item.extendData.deviateFlag : 2)
		}
		let xAxis_data = item.xaxis || [];
		let series_data = [
			{ data: needDataMin },
			{ data: needDataMax },
			{ data: needDataMedian },
		];
		let expansion_data = item.xaxisCn || [];
		let markArea_range = item.range || [];
		if (markArea_range.length != 2) {
			markArea_range = [];
		}
		return getEchartsOptionFloatA3(xAxis_data, series_data, expansion_data, markArea_range, type == 0, deviateFlags)
	}

	return null;
}

function getNeedIcon(item) { // 获取 icon
	if (item.index == 'brePauseNum' || item.index == 'heartFastNum' || item.index == 'fallStopNum' || item.index == 'heartSlowNum' || item.index == 'breFastNum' || item.index == 'fallNum' || item.index == 'outBedNum') {
		return 'icon_work_proposal_icon_1';
	} else if (item.index == 'breBpm' || item.index == 'breRatio' || item.index == 'ahi') {
		return 'icon_work_proposal_icon_0';
	} else if (item.index == 'bmRatio') {
		return 'icon_work_proposal_icon_2';
	} else if (item.index == 'heartBpm') {
		return 'icon_work_proposal_icon_3';
	} else if (item.index == 'getBed' || item.index == 'sleepSt' || item.index == 'sleepEd' || item.index == 'leaveBed' || item.index == 'bcFallAsleep') {
		return 'icon_work_proposal_icon_4';
	} else if (item.index == 'obCnt') {
		return 'icon_work_proposal_icon_5';
	} else if (item.index == 'obTimeLen2' || item.index == 'sleepTime' || item.index == 'sleepEff' || item.index == 'sleepBreak' || item.index == 'obCntTimeLen2') {
		return 'icon_work_proposal_icon_6';
	} else if (item.index == 'fallIndex') {
		return 'icon_work_proposal_icon_13';
	} else if (item.index == 'breBpm3Num' || item.index == 'breBpm2Num') {
		return 'icon_work_proposal_icon_7';
	} else if (item.index == 'bmRatio2Num') {
		return 'icon_work_proposal_icon_8';
	} else if (item.index == 'heartBpm3Num' || item.index == 'heartBpm2Num') {
		return 'icon_work_proposal_icon_9';
	} else if (item.index == 'bcRegular2Num' || item.index == 'bcFallAsleep2Num') {
		return 'icon_work_proposal_icon_10';
	} else if (item.index == 'obCnt3Num' || item.index == 'obTime2Num' || item.index == 'obTime2Cnt3Num') {
		return 'icon_work_proposal_icon_11';
	} else if (item.index == 'sleepTime3Num' || item.index == 'sleepTime2Num' || item.index == 'sleepEff3Num' || item.index == 'sleepBreak2Num') {
		return 'icon_work_proposal_icon_12';
	}
	return null;
}

function getNeedQuestionMarkType(item) { // 获取问号类型
	return null;
}

function getNeedSubTitle(item) { // 获取子标题
	if (item.index == 'ahi') {
		return 'ahi';
	} else if (item.index == 'breBpm2Num' || item.index == 'breBpm3Num') {
		return '呼吸率分布'
	} else if (item.index == 'bmRatio2Num') {
		return '每晚体动指数'
	} else if (item.index == 'obCnt3Num') {
		return '每晚离床次数'
	} else if (item.index == 'sleepTime2Num' || item.index == 'sleepTime3Num') {
		return '每晚睡眠时长'
	} else if (item.index == 'sleepEff3Num') {
		return '每晚睡眠效率'
	} else if (item.index == 'heartBpm2Num' || item.index == 'heartBpm3Num') {
		return '心率分布'
	} else if (item.index == 'bcRegular2Num') {
		return '上床、入睡、醒来、起床时间点分布'
	} else if (item.index == 'bcFallAsleep2Num') {
		return '每晚入睡时长'
	} else if (item.index == 'obTime2Num') {
		return '每晚离床时长'
	}
	return null;
}

function getNeedSubQuestionMarkType(item) { // 获取子问号类型
	if (item.index == 'ahi') {
		return 'ahi';
	} else if (item.index == 'bmRatio2Num') {
		return 'bmRatio2Num';
	}
	return null;
}

function getNeedLeftTip(item) { // 获取 Tip 左
	if (item.index == 'obTimeLen2' || item.index == 'breBpm' || item.index == 'breRatio' || item.index == 'bmRatio' || item.index == 'heartBpm' || item.index == 'getBed' || item.index == 'sleepSt' || item.index == 'sleepEd' || item.index == 'leaveBed' || item.index == 'bcFallAsleep' || item.index == 'obCnt' || item.index == 'sleepTime' || item.index == 'sleepEff' || item.index == 'sleepBreak' || item.index == 'bmRatio2Num' || item.index == 'obCnt3Num' || item.index == 'sleepTime2Num' || item.index == 'sleepTime3Num' || item.index == 'sleepEff3Num' || item.index == 'bcFallAsleep2Num' || item.index == 'obTime2Num') {
		return '日常表现';
	} else if (item.index == 'fallIndex' || item.index == 'breBpm2Num' || item.index == 'breBpm3Num' || item.index == 'heartBpm2Num' || item.index == 'heartBpm3Num') {
		return '参考范围';
	}
}

function getNeedRightTip(item) { // 获取 Tip 右
	if (item.index == 'breBpm2Num' || item.index == 'breBpm3Num') {
		return '横轴为呼吸率(次/分)';
	} else if (item.index == 'heartBpm2Num' || item.index == 'heartBpm3Num') {
		return '横轴为心率(次/分)';
	}
}

export default {
	getNeedOption,
	getNeedIcon,
	getNeedQuestionMarkType,
	getNeedSubTitle,
	getNeedSubQuestionMarkType,
	getNeedLeftTip,
	getNeedRightTip
}

/**
 * 需及时关心长者-指标:
 * outBedNum - 发生X次离床过久报警
 * fallNum - 发生X次跌倒报警
 * breFastNum - 发生X次呼吸过速报警
 * brePauseNum - 发生X次呼吸暂停过久报警
 * heartFastNum - 发生X次心动过速报警
 * heartSlowNum - 发生X次心动过缓报警
 * fallStopNum - 发生X次卫生间停留过久报警
 * breBpm - 呼吸率X
 * breRatio - 吸呼比X
 * bmRatio - 体动指数X
 * heartBpm - 心率X
 * getBed - 上床时间比日常X
 * sleepSt - 入睡时间比日常X
 * sleepEd - 醒来时间比日常X
 * leaveBed - 起床时间比日常X
 * bcFallAsleep - 入睡时长X
 * obCnt - %s多次%s起夜
 * obTimeLen2 - 离床时长X
 * sleepTime - 睡眠时长X
 * sleepEff - 睡眠效率X
 * sleepBreak - 睡眠%s破碎%s
 * ahi - 呼吸异常指数高于X
 * fallIndex - 跌倒风险指数高于X
 * obCntTimeLen2 - 多次起夜+离床时长变长
 * 
 * 需长期观察长者-指标:
 * breBpm3Num - 呼吸偏慢
 * breBpm2Num - 呼吸急促
 * bmRatio2Num - 睡眠不踏实
 * heartBpm3Num - 心率较慢
 * heartBpm2Num - 心率较快
 * bcRegular2Num - 晚睡早起
 * bcFallAsleep2Num - 入睡困难户
 * obCnt3Num - 频繁起夜
 * obTime2Num - 离床时长久
 * sleepTime3Num - 睡不醒
 * sleepTime2Num - 睡得少
 * sleepEff3Num - 低效睡眠
 * sleepBreak2Num - 睡眠破碎
 * obTime2Cnt3Num - 多次起夜+离床时长变长
 */